import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { Button, Checkbox, FormControlLabel, Stack } from "@mui/material";
import useTranslation from "../../hooks/useTranslation";

interface LawyerAgreementDialogProps {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  onAccept: () => void;
}

const LawyerAgreementDialog = ({
  isOpen,
  setIsOpen,
  onAccept,
}: LawyerAgreementDialogProps) => {
  const { t } = useTranslation();
  const [accepted, setAccepted] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (isOpen) {
      setAccepted(false);
    }
  }, [isOpen]);

  const handleVerify = () => {
    onAccept();
  };

  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className="adminCaseItemDialog"
    >
      <DialogActions className="dialogActions">
        <Button onClick={() => setIsOpen(false)} color={"error"}>
          &times;
        </Button>
      </DialogActions>
      <DialogContent className={"pt pr pl pb"}>
        <p
          dangerouslySetInnerHTML={{
            __html: t("lawyer-application-legal-warning"),
          }}
        />
        <Stack direction={"row"} justifyContent={"space-between"}>
          <FormControlLabel
            control={
              <Checkbox
                value={accepted}
                onChange={() => setAccepted(!accepted)}
              />
            }
            label={t("lawyerAgreementAccept")}
          />
          <Button disabled={!accepted} onClick={handleVerify}>
            {t("approve")}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default LawyerAgreementDialog;
